<template>
<b-modal
    id="incident-panel"
    ref="incident-modal"
    hide-header
    hide-footer
    @show="scrollLtiFrameToTop"
    @shown="onShown"
>
    <div v-if="classroom" class="incident-panel-content">
        <div class="incident-text">
            {{ $t("sessions.incidentpanel.infotext", { sessiondatetime: classroomStartDateTime }) }}
        </div>

        <textarea v-model="description" rows="10"></textarea>

        <div class="incident-footer">
            <button class="page-controls__primary-action button primary" @click="sendIncident()">
              <span>{{ $t("sessions.incidentpanel.buttontext") }}</span>
            </button>
        </div>
    </div>
</b-modal>
</template>
<script>
import jwtMixin from '../../../mixins/jwtMixin'
import utilitiesMixin from '../../../mixins/utilitiesMixin'
import ltiFrameMixin from '../../../mixins/ltiFrameMixin'

export default {
  name: 'IncidentPanel',
  components: {},
  mixins: [jwtMixin, utilitiesMixin, ltiFrameMixin],
  props: ['classroom'],
  mounted () {
    this.$moment.locale('es')
  },
  created () {
    this.$i18n.locale = this.jwtLanguage()
  },
  data () {
    return {
      description: null,
      last_classroom_id: null
    }
  },
  computed: {
    classroomStartDateTime () {
      return window.moment(this.classroom.start).format(this.$i18n.t('sessions.incidentpanel.sessiondatetimeformat'))
    }
  },
  methods: {
    onShown () {
      // si el panel corresponde a otra sesión, borramos el texto
      if (this.last_classroom_id !== this.classroom.id) {
        this.description = null
      }
      this.last_classroom_id = this.classroom.id
    },
    sendIncident () {
      // comprobamos si hay texto para enviar
      if (!this.description) {
        this.$noty.error(this.$i18n.t('sessions.incidentpanel.emptydescription'), {
          closeWith: ['button']
        })
      } else {
        const userId = this.jwtLoggedUserId()

        let incident = {
          classroomId: this.classroom.id,
          userId: userId,
          description: this.description
        }
        // mandamos incidencia
        window.axios.post(`classrooms/incident`, incident).then((response) => {
          // todo OK
          if (response.status === 200) {
            this.$refs['incident-modal'].hide()
            // borramos texto
            this.description = null
            // mostramos notificación
            this.$noty.success(this.$i18n.t('sessions.incidentpanel.sentok'), {
              closeWith: ['button']
            })
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Lti/SessionsModals/IncidentPanel.vue